<template>
  <svg
    class="size-4"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="18"
      x2="6"
      y1="6"
      y2="18"
    />
    <line
      x1="6"
      x2="18"
      y1="6"
      y2="18"
    />
  </svg>
</template>
